import {
    SET_USER_IDENTIFICATION, GET_USER_IDENTIFICATION,
    GET_USER_AUTHORIZATION, SET_USER_AUTHORIZATION
} from '../types/General/userActionTypes'

// const fillUserFromLocalStore = () => {
//     if (localStorage.getItem("user-info")) {
//         return JSON.parse(localStorage.getItem("user-info"));
//     }
//     return {};
// }

const initialState = {
    // user: fillUserFromLocalStore()
    user: {},
    userAuthorization: {}
};


const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_IDENTIFICATION:
            {
                return {
                    ...state,
                    user: action.payload
                };
            }
        case GET_USER_IDENTIFICATION:
            {
                return {
                    ...state
                };
            }            
        default:
            return state;
    }
}

export default userReducer;

